module.exports = __webpack_public_path__ + "static/media/img_hero_whyreits.9e492f5f.jpg";